export default __webpack_public_path__ + "static/media/25083004.b036d7cb.jpg";